import { Navigate, Route, Routes } from 'react-router-dom';
import { SignInPage } from '@pages/SignIn';
import {
  UnauthenticatedPath,
  SuperAdminUnauthenticatedPath,
} from '@shared/constants/routes.constants';
import { SuperAdminSignInPage } from '@pages/SuperAdminSignIn';

export const UnauthorizedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SignInPage />} />

      <Route path={UnauthenticatedPath.SIGN_IN} element={<SignInPage />} />
      <Route path={SuperAdminUnauthenticatedPath.SIGN_IN} element={<SuperAdminSignInPage />} />
      <Route path="*" element={<Navigate to={UnauthenticatedPath.SIGN_IN} replace />} />
    </Routes>
  );
};
